import { CLEAR_PARTNERS,
         SET_PARTNERS,
         ADD_PARTNER,
         SET_ERRORS,
         CLEAR_ERRORS,
         MANAGE_LOADING_PARTNERS,
         MANAGE_EDITING_PARTNER } from './mutation-types.js';
import { partnerDataSvc } from '../../../shared/services/data-service-partner.js';

async function retrievePartnersByTypeCode(partnerType) {
    const searchInfo = { pageSize: 200 };
    const partnersByTypeCode = {
        partnerType: partnerType,
        partners: []
    };
    var pageInfo = await partnerDataSvc.findPartners(searchInfo, partnerType.code);
    partnersByTypeCode.partners.push.apply(partnersByTypeCode.partners, pageInfo.partners);
    while (pageInfo.nextPageLink) {
        searchInfo['pageLink'] = pageInfo.nextPageLink;
        pageInfo = await partnerDataSvc.findPartners(searchInfo, partnerType.code);
        partnersByTypeCode.partners.push.apply(partnersByTypeCode.partners, pageInfo.partners);
    }
    return partnersByTypeCode;
}

export default {
    async loadPartnersByType(context, payload) {
        context.commit(MANAGE_LOADING_PARTNERS, true);
        context.commit(CLEAR_PARTNERS);
        for (const partnerType of payload) {
            const partnersByTypeCode = await retrievePartnersByTypeCode(partnerType);
            context.commit(SET_PARTNERS, partnersByTypeCode);
        }
        context.commit(MANAGE_LOADING_PARTNERS, false);
    },
    async createPartner(context, payload) {
        context.commit(MANAGE_EDITING_PARTNER, true);
        context.commit(CLEAR_ERRORS);
        const results = await partnerDataSvc.createPartner(payload);
        if (results.successful) {
            context.commit(ADD_PARTNER, results.partner);
        } else {
            context.commit(SET_ERRORS, results.errors);
        }
        context.commit(MANAGE_EDITING_PARTNER, false);
    },
}